import { MOBILE_BREAKPOINT } from './settings';

const mq = window.matchMedia(`(width < ${MOBILE_BREAKPOINT}px)`);

export function isMobile() {
	return mq.matches;
}
